var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganeCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.34961,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#FFECE8",
    stroke: "#FEC5B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 29.436L17.2074 25.643C17.0188 25.4609 16.7662 25.3601 16.504 25.3623C16.2418 25.3646 15.991 25.4698 15.8056 25.6552C15.6202 25.8406 15.515 26.0914 15.5127 26.3536C15.5105 26.6158 15.6112 26.8684 15.7934 27.057L20.2934 31.557C20.4809 31.7445 20.7352 31.8498 21.0004 31.8498C21.2656 31.8498 21.5199 31.7445 21.7074 31.557L32.7074 20.557C32.8896 20.3684 32.9904 20.1158 32.9881 19.8536C32.9858 19.5914 32.8806 19.3406 32.6952 19.1552C32.5098 18.9698 32.259 18.8646 31.9968 18.8623C31.7346 18.8601 31.482 18.9609 31.2934 19.143L21.0004 29.436Z",
    fill: "#FD4319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganeCheckmark);
export default __webpack_public_path__ + "static/media/OrganeCheckmark.6c0b21b052565bd6436e69503a2977dd.svg";
export { ForwardRef as ReactComponent };